
import Vue from "vue";
import ImageCropper from "@/components/ImageCropper.vue";
import toast from "@/functions/toast.function";
import { getToken } from "@/functions/token.function";

export default Vue.extend({
  components: { ImageCropper },
  data() {
    return {
      form: {
        categoryFeedback: "",
        satisfaction: null,
        easeOfUse: null,
        recommend: null,
        favoriteFeature: "",
        obstacles: "",
        futureFeatures: "",
        suggestions: "",
        attachment: null as File | null,
      },
      showCropper: false,
      cropperData: "",
      submitting: false,
    } as {
      form: {
        categoryFeedback: string;
        satisfaction: number | null;
        easeOfUse: number | null;
        recommend: number | null;
        favoriteFeature: string;
        obstacles: string;
        futureFeatures: string;
        suggestions: string;
        attachment: File | null;
      };
      showCropper: boolean;
      cropperData: string;
      submitting: boolean;
    };
  },
  computed: {
    isLoggedIn(): boolean {
      const user = this.$store?.state?.auth?.user;
      return !!getToken();
    }
  },
  methods: {
    openModal() {
      const modal = this.$refs.feedbackModal as any;
      if (modal && typeof modal.show === "function") {
        modal.show();
      }
    },
    closeModal() {
      const modal = this.$refs.feedbackModal as any;
      if (modal && typeof modal.hide === "function") {
        modal.hide();
      }
    },
    handleFileSelected(event: Event) {
      const input = event.target as HTMLInputElement;
      const file = input.files ? input.files[0] : null;
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropperData = (e.target && e.target.result) ? String(e.target.result) : "";
        this.showCropper = true;
      };
      reader.readAsDataURL(file);
    },
    onImageCropped(file: File) {
      this.form.attachment = file;
    },
    submitFeedback() {
      this.submitting = true;

      const categoryMap: Record<string, number> = {
        general: 1,
        course: 2,
        instructor: 3,
        payment: 4,
      };

      const formData = new FormData();
      formData.append("category", String(categoryMap[this.form.categoryFeedback] || 1));
      formData.append("overall_satisfaction", String(this.form.satisfaction || 0));
      formData.append("ease_of_use", String(this.form.easeOfUse || 0));
      formData.append("recommendation_score", String(this.form.recommend || 0));
      formData.append("favorite_feature", this.form.favoriteFeature);
      formData.append("encountered_issues", this.form.obstacles);
      formData.append("requested_features", this.form.futureFeatures);
      formData.append("additional_feedback", this.form.suggestions);
      if (this.form.attachment) {
        formData.append("attachment", this.form.attachment);
      }

      this.$store.dispatch("general/submitFeedback", {
        params: formData,
        success: () => {
          toast.success("Feedback submitted successfully!", "Success");
          this.closeModal();
          this.resetForm();
        },
        finally: () => {
          this.submitting = false;
        },
      });
    },
    resetForm() {
      this.form = {
        categoryFeedback: "",
        satisfaction: null,
        easeOfUse: null,
        recommend: null,
        favoriteFeature: "",
        obstacles: "",
        futureFeatures: "",
        suggestions: "",
        attachment: null,
      };
      const attachmentInput = this.$el.querySelector<HTMLInputElement>("#attachment");
      if (attachmentInput) {
        attachmentInput.value = "";
      }
      this.cropperData = "";
      this.showCropper = false;
      this.submitting = false;
    },
  },
});
